import CloseCircle from "../../../images/CloseCircle.svg";
import './checkboxWithLabel.scss';
import PropTypes from "prop-types";

function CheckboxWithLabel({ name, onChange, value, deletable, onDelete, locked }) {
    return (
        <label className="checkBoxWithLabel">
            <div>
                <input
                    type="checkbox"
                    className="customCheckbox"  
                    checked={value}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={locked}
                />
                <p>{name}</p>
            </div>
            {deletable && (
                <button onClick={() => onDelete(name)}>
                    <img src={CloseCircle} alt="Delete" />
                </button>
            )}
        </label>
    );
}



CheckboxWithLabel.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool.isRequired,
    deletable: PropTypes.bool,
    onDelete: PropTypes.func,
    locked: PropTypes.bool
}

export default CheckboxWithLabel;
